// https://www.dbos.dev/

import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend } from '@components/layout/FooterCtas';
import { HomeRecentPosts } from '@components/cms/HomeRecentPosts';
import { HeroGlow, HowItWorks, InViewSection, SlideIn } from '@components/interactions';
import { CodeSource } from '@components/interactions/CodeBlock';
import { Lightbox, Lottie, TabContent, TabLink, TabPane, Tabs } from '@components/webflow';
import { posts } from '@content/blog';

export function HomePage() {
  return (
    <SiteLayout banner={true} footerCta={<FooterCtaBuildYourReliableBackend />}>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "/* Target Webflow's native tab content wrapper */\n  .w-tab-content {\n    /* Adjust 0.4s to match how fast you want the height to morph */\n    transition: height 0.4s cubic-bezier(0.5, 1, 0.5, 1); \n    overflow: hidden; \n  }",
        }}
      />
      <style
        dangerouslySetInnerHTML={{
          __html:
            "pre {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  box-sizing: border-box;\n  overflow-x: auto;\n}\n\ncode {\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  max-width: 100%;\n  display: inline-block;\n}\n\n.is-post {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* Code samples in the \"code tabs\" cards */\n.layout-code_code-block pre {\n  margin: 0;\n}\n\n.layout-code_code-block pre code.hljs {\n  display: block;\n  max-width: 100%;\n  padding: 1.5rem 2rem;\n  overflow-x: auto;\n  background: var(--_primitives-july-2025---ink-900);\n  color: var(--_primitives-july-2025---white);\n  font-family: var(--_ui-styles-july-2025---typography--code), Menlo, Consolas, 'Courier New', monospace;\n  font-size: 0.875rem;\n  line-height: 1.7;\n  font-variant-ligatures: none;\n  /* Scroll long lines instead of wrapping them, which breaks Python's indentation */\n  white-space: pre;\n  word-wrap: normal;\n  overflow-wrap: normal;\n  scrollbar-width: thin;\n  scrollbar-color: var(--_primitives-july-2025---ink-500) transparent;\n}\n\n.layout-code_code-block pre code.hljs ::selection {\n  background: #48e1fe33;\n}\n\n/* def, return, async, await, if, for, import, ... */\n.layout-code_code-block .hljs-keyword {\n  color: #48e1fe;\n}\n\n/* @DBOS.workflow(), @DBOS.step(), ... */\n.layout-code_code-block .hljs-meta {\n  color: var(--color-palette--color-splice-500);\n}\n\n.layout-code_code-block .hljs-title.function_,\n.layout-code_code-block .hljs-title.class_ {\n  color: var(--_primitives-july-2025---white);\n  font-weight: 600;\n}\n\n.layout-code_code-block .hljs-string {\n  color: var(--_primitives-july-2025---splice-500);\n}\n\n.layout-code_code-block .hljs-subst {\n  color: var(--_primitives-july-2025---white);\n}\n\n.layout-code_code-block .hljs-number,\n.layout-code_code-block .hljs-literal {\n  color: #80d4ff;\n}\n\n.layout-code_code-block .hljs-built_in,\n.layout-code_code-block .hljs-type {\n  color: var(--color-palette--color-lily-500);\n}\n\n.layout-code_code-block .hljs-params,\n.layout-code_code-block .hljs-variable,\n.layout-code_code-block .hljs-property,\n.layout-code_code-block .hljs-punctuation,\n.layout-code_code-block .hljs-operator {\n  color: inherit;\n}\n\n.layout-code_code-block .hljs-comment {\n  color: var(--_primitives-july-2025---ink-300);\n  font-style: italic;\n}\n\n@media screen and (max-width: 767px) {\n  .layout-code_code-block pre code.hljs {\n    padding: 1.25rem;\n    font-size: 0.8125rem;\n  }\n}\n",
        }}
      />
      <section className="section_hero-home">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large padding-top">
              <div className="product_component">
                <div className="max-width-large">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-small">
                      <div className="tagline-container_glow">
                        <div className="div-block-76">
                          <div className="w-embed">
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M6.26021 3.93463C6.48276 3.3332 7.33342 3.33321 7.55596 3.93464L8.66366 6.92815C8.73363 7.11724 8.88272 7.26632 9.07181 7.33629L12.0653 8.44399C12.6668 8.66654 12.6667 9.51719 12.0653 9.73974L9.07181 10.8474C8.88272 10.9174 8.73363 11.0665 8.66366 11.2556L7.55596 14.2491C7.33342 14.8505 6.48276 14.8505 6.26021 14.2491L5.15251 11.2556C5.08254 11.0665 4.93346 10.9174 4.74437 10.8474L1.75086 9.73974C1.14943 9.51719 1.14943 8.66654 1.75086 8.44399L4.74437 7.33629C4.93346 7.26632 5.08254 7.11724 5.15251 6.92815L6.26021 3.93463Z"
                                fill="currentColor"
                              />
                              {'\n'}
                              <path
                                d="M12.0599 1.31314C12.2268 0.86207 12.8648 0.862071 13.0317 1.31314L13.3961 2.29771C13.4485 2.43953 13.5604 2.55134 13.7022 2.60382L14.6867 2.96814C15.1378 3.13505 15.1378 3.77304 14.6867 3.93995L13.7022 4.30427C13.5604 4.35675 13.4485 4.46856 13.3961 4.61038L13.0317 5.59495C12.8648 6.04602 12.2268 6.04602 12.0599 5.59494L11.6956 4.61038C11.6431 4.46856 11.5313 4.35675 11.3895 4.30427L10.4049 3.93995C9.95387 3.77304 9.95387 3.13505 10.4049 2.96814L11.3895 2.60382C11.5313 2.55134 11.6431 2.43953 11.6956 2.29771L12.0599 1.31314Z"
                                fill="currentColor"
                              />
                              {'\n'}
                            </svg>
                          </div>
                          <h1 className="text-size-small tagline-container is-glow is-ai">
                            Durable AI Workflow Orchestration
                          </h1>
                        </div>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <h2 className="heading-style-h1">
                        {'Build reliable software '}
                        <span className="text-gradient">effortlessly</span>
                      </h2>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div className="max-width-medium is-home">
                        <p className="text-body-active">
                          Add durable workflows to your application or AI agent to make it resilient to any failure. No
                          infrastructure required, just use Postgres.
                        </p>
                      </div>
                    </div>
                    <div className="margin-bottom margin-small">
                      <div className="button-group is-center">
                        <div data-wf--button--variant="primary-large" className="button-wrapper">
                          <a href="https://console.dbos.dev/" className="button w-inline-block">
                            <div className="text-block-4">Start for free</div>
                            <div className="icon-chevron-right w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                        <div
                          data-wf--button--variant="secondary-large"
                          className="button-wrapper w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1"
                        >
                          <a
                            href="https://docs.dbos.dev/quickstart"
                            target="_blank"
                            className="button w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-inline-block"
                          >
                            <div className="text-block-4 w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1">
                              Read the docs
                            </div>
                            <div className="icon-chevron-right w-variant-13e9e47c-e174-bff0-1887-a9d5644710a1 w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="hero_logo-collection">
                    <div className="text-size-small">Works with your favorites</div>
                    <div className="ai_logo-collection-list">
                      <img
                        src="/assets/images/69d33a40e863352325142182_claude.avif"
                        loading="lazy"
                        alt=""
                        className="ai_logo-collection-item"
                      />
                      <img
                        src="/assets/images/69d33a407bb8f1d52d80174f_openai.avif"
                        loading="lazy"
                        alt=""
                        className="ai_logo-collection-item"
                      />
                      <img
                        src="/assets/images/69d33a416990c0267dd88e09_llama-index.avif"
                        loading="lazy"
                        alt=""
                        className="ai_logo-collection-item"
                      />
                      <img
                        src="/assets/images/69d33a40773935375f8cde74_databricks.avif"
                        loading="lazy"
                        alt=""
                        className="ai_logo-collection-item"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_code">
        <HeroGlow
          style={{
            WebkitTransform: 'translate3d(0, 5rem, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
            MozTransform: 'translate3d(0, 5rem, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
            msTransform: 'translate3d(0, 5rem, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
            transform: 'translate3d(0, 5rem, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)',
            opacity: '0',
          }}
          className="layout_glow-container"
          as="div"
        >
          <img
            src="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif"
            loading="lazy"
            sizes="(max-width: 3999px) 100vw, 3999px"
            srcSet="/assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-500.avif 500w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-800.avif 800w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1080.avif 1080w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-1600.avif 1600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2000.avif 2000w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-2600.avif 2600w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow-p-3200.avif 3200w, /assets/images/69d0de0309969309164fe0c1_cca404b7c59481628bc5e289d68b3fc0_dbos-hero-glow.avif 3999w"
            alt=""
            className="layout_code-glow"
          />
        </HeroGlow>
        <div className="padding-hero is-glow">
          <div className="container-large">
            <div className="padding-section-medium padding-top">
              <div className="layout_code-tab-wrapper">
                <div className="layout_code-tab-component">
                  <Tabs
                    data-duration-in="0"
                    data-duration-out="0"
                    data-current="AI agents"
                    data-easing="ease"
                    className="layout-code_tabs w-tabs"
                  >
                    <div
                      id="w-node-_0c57cbb6-399e-1fce-658f-c3dac686a1cc-c6f7e10f"
                      className="layout-code_tabs-menu w-tab-menu"
                    >
                      <TabLink
                        data-w-tab="AI agents"
                        className="layout-code_tab-link w-inline-block w-tab-link w--current"
                      >
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M16.5537 7.05416C16.6709 6.64263 16.6964 6.21035 16.6281 5.78791C16.5599 5.36547 16.3997 4.96318 16.1588 4.6095C15.9179 4.25582 15.6023 3.95938 15.2342 3.74116C14.8661 3.52294 14.4545 3.38826 14.0287 3.34666C13.8578 2.85634 13.5387 2.43127 13.1156 2.13028C12.6925 1.82929 12.1862 1.66728 11.667 1.66666C11.05 1.66875 10.4558 1.90046 10.0003 2.31666C9.54481 1.90046 8.95067 1.66875 8.33366 1.66666C7.24949 1.66666 6.32533 2.35916 5.97949 3.34582C5.55285 3.38639 5.14037 3.52034 4.7713 3.73818C4.40223 3.95602 4.08562 4.2524 3.84392 4.60631C3.60223 4.96022 3.44138 5.36298 3.37278 5.78602C3.30419 6.20906 3.32952 6.64201 3.44699 7.05416C2.91202 7.33878 2.46408 7.76292 2.15069 8.28157C1.8373 8.80021 1.67016 9.39402 1.66699 9.99999C1.66699 10.8958 2.02366 11.7383 2.64366 12.36C2.54879 12.6757 2.50051 13.0036 2.50033 13.3333C2.50033 14.9642 3.67699 16.325 5.25533 16.6117C5.48703 17.1238 5.86119 17.5584 6.33314 17.8637C6.80509 18.1689 7.35491 18.332 7.91699 18.3333C8.73283 18.3333 9.47033 17.9942 10.0003 17.4508C10.2708 17.7299 10.5946 17.9518 10.9525 18.1034C11.3104 18.255 11.695 18.3332 12.0837 18.3333C12.6447 18.3323 13.1937 18.1699 13.665 17.8655C14.1364 17.5611 14.5102 17.1276 14.742 16.6167C15.207 16.5347 15.6492 16.355 16.0397 16.0895C16.4301 15.824 16.7597 15.4787 17.0069 15.0765C17.254 14.6742 17.413 14.224 17.4733 13.7558C17.5337 13.2875 17.494 12.8118 17.357 12.36C17.6668 12.0501 17.9126 11.6821 18.0801 11.2772C18.2477 10.8722 18.3339 10.4382 18.3337 9.99999C18.3305 9.39402 18.1634 8.80021 17.85 8.28157C17.5366 7.76292 17.0886 7.33878 16.5537 7.05416ZM7.91699 16.6667C7.32449 16.6667 6.80866 16.2467 6.69199 15.6683L6.51533 15H5.83366C4.91449 15 4.16699 14.2525 4.16699 13.3333C4.16699 13.04 4.23783 12.765 4.37783 12.5158L4.75783 11.8358L4.10449 11.4108C3.86848 11.2587 3.6743 11.0499 3.53966 10.8034C3.40502 10.557 3.3342 10.2808 3.33366 9.99999C3.33366 9.18582 3.93616 8.47999 4.73533 8.35666L6.14616 8.13999L5.26366 7.01832C5.1065 6.81572 5.01536 6.56973 5.00256 6.31363C4.98976 6.05754 5.05593 5.80369 5.1921 5.58643C5.32828 5.36916 5.5279 5.19896 5.76396 5.09885C6.00003 4.99873 6.26114 4.97353 6.51199 5.02666L7.50033 5.17249V4.16666C7.50033 3.94564 7.58812 3.73368 7.7444 3.5774C7.90068 3.42112 8.11264 3.33332 8.33366 3.33332C8.55467 3.33332 8.76663 3.42112 8.92291 3.5774C9.07919 3.73368 9.16699 3.94564 9.16699 4.16666V15.4167C9.16699 16.1058 8.60616 16.6667 7.91699 16.6667ZM15.8962 11.41L15.2428 11.835L15.6228 12.515C15.7628 12.765 15.8337 13.04 15.8337 13.3333C15.8337 14.2525 15.0862 15 14.1253 15H13.4437L13.3087 15.6683C13.2504 15.9502 13.0968 16.2034 12.8736 16.3853C12.6505 16.5671 12.3715 16.6665 12.0837 16.6667C11.3945 16.6667 10.8337 16.1058 10.8337 15.4167V4.16666C10.8337 3.70666 11.207 3.33332 11.667 3.33332C12.127 3.33332 12.5003 3.70666 12.5003 4.20832V5.21416L13.4887 5.02666C13.7395 4.97353 14.0006 4.99873 14.2367 5.09885C14.4728 5.19896 14.6724 5.36916 14.8085 5.58643C14.9447 5.80369 15.0109 6.05754 14.9981 6.31363C14.9853 6.56973 14.8942 6.81572 14.737 7.01832L13.8545 8.14082L15.2653 8.35749C15.6557 8.4207 16.011 8.62056 16.2677 8.9214C16.5244 9.22224 16.666 9.6045 16.667 9.99999C16.667 10.5692 16.3787 11.0958 15.8962 11.41Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">{'AI\u00a0agents'}</h3>
                      </TabLink>
                      <TabLink
                        data-w-tab="Durable execution"
                        className="layout-code_tab-link w-inline-block w-tab-link"
                      >
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.11023 12.8175V7.18249C8.11023 7.04096 8.16982 6.93909 8.28898 6.87686C8.40801 6.81464 8.53142 6.82159 8.65919 6.8977L13.0134 9.69436C13.1239 9.77034 13.1792 9.87221 13.1792 9.99999C13.1792 10.1278 13.1239 10.2296 13.0134 10.3056L8.65919 13.1023C8.53142 13.1784 8.40801 13.1853 8.28898 13.1231C8.16982 13.0609 8.11023 12.959 8.11023 12.8175ZM2.12836 14.8302V16.8642C2.12836 17.0679 2.06107 17.2371 1.92648 17.3719C1.79176 17.5064 1.62253 17.5737 1.41878 17.5737C1.21489 17.5737 1.04565 17.5064 0.911068 17.3719C0.776346 17.2371 0.708984 17.0679 0.708984 16.8642V13.0452C0.708984 12.8414 0.776346 12.6722 0.911068 12.5375C1.04565 12.4029 1.21489 12.3356 1.41878 12.3356H5.21669C5.42058 12.3356 5.58982 12.4029 5.7244 12.5375C5.85912 12.6722 5.92648 12.8414 5.92648 13.0452C5.92648 13.2491 5.85912 13.4183 5.7244 13.5529C5.58982 13.6876 5.42058 13.755 5.21669 13.755H3.11482C3.89982 15.0512 4.90572 16.0548 6.13253 16.7656C7.35919 17.4764 8.69704 17.8319 10.1461 17.8319C11.6777 17.8319 13.0741 17.416 14.335 16.5844C15.5959 15.7527 16.5371 14.6458 17.1588 13.2635C17.2627 13.0287 17.3966 12.8429 17.5607 12.7062C17.7248 12.5697 17.9227 12.5272 18.1542 12.5787C18.372 12.6304 18.5187 12.7583 18.5944 12.9625C18.6702 13.1665 18.6562 13.3758 18.5523 13.5902C17.844 15.3039 16.7325 16.6767 15.2179 17.7085C13.7032 18.7403 12.0126 19.2562 10.1461 19.2562C8.48218 19.2562 6.96072 18.873 5.58169 18.1067C4.2028 17.3401 3.05169 16.248 2.12836 14.8302ZM1.45044 9.13686C1.23266 9.13686 1.06773 9.06173 0.955651 8.91145C0.843429 8.76117 0.806207 8.57888 0.843984 8.36457C0.951762 7.67291 1.13079 7.03756 1.38107 6.45853C1.63135 5.87964 1.95822 5.29985 2.36169 4.71916C2.4828 4.52929 2.64176 4.417 2.83857 4.38228C3.03537 4.34756 3.21155 4.40624 3.36711 4.55832C3.53322 4.72777 3.61176 4.9152 3.60273 5.12061C3.59385 5.32617 3.53051 5.53082 3.41273 5.73457C3.13051 6.15971 2.90044 6.58402 2.72253 7.00749C2.54475 7.43096 2.40364 7.89193 2.29919 8.39041C2.24419 8.61138 2.14426 8.79103 1.9994 8.92936C1.8544 9.0677 1.67141 9.13686 1.45044 9.13686ZM9.18857 1.4452C9.18857 1.6695 9.116 1.85332 8.97086 1.99666C8.82558 2.13985 8.64412 2.23895 8.42648 2.29395C7.91079 2.39839 7.4369 2.54464 7.00482 2.7327C6.57273 2.92089 6.13718 3.16138 5.69815 3.45416C5.50496 3.57193 5.30558 3.62749 5.10003 3.62082C4.89461 3.61429 4.71412 3.52798 4.55857 3.36186C4.41371 3.21686 4.356 3.04679 4.38544 2.85166C4.41489 2.65652 4.5176 2.49672 4.69357 2.37228C5.2776 1.95506 5.86503 1.62388 6.45586 1.37874C7.04669 1.13374 7.69496 0.950406 8.40065 0.82874C8.61496 0.794295 8.79989 0.834017 8.95544 0.947906C9.11086 1.06179 9.18857 1.22756 9.18857 1.4452ZM15.4319 3.36186C15.2763 3.5345 15.0959 3.61818 14.8904 3.61291C14.6849 3.60763 14.4855 3.5445 14.2923 3.42353C13.8533 3.13395 13.422 2.89777 12.9986 2.71499C12.5751 2.53207 12.1072 2.39006 11.5948 2.28895C11.3738 2.24784 11.1942 2.15304 11.0559 2.00457C10.9177 1.85596 10.8486 1.6695 10.8486 1.4452C10.8486 1.22756 10.9236 1.06179 11.0738 0.947906C11.2241 0.834017 11.4063 0.794295 11.6207 0.82874C12.3091 0.943184 12.9471 1.12124 13.5346 1.36291C14.1222 1.60471 14.7011 1.93256 15.2711 2.34645C15.4504 2.47423 15.5609 2.63652 15.6025 2.83332C15.6442 3.03013 15.5873 3.20631 15.4319 3.36186ZM18.545 9.14166C18.3241 9.14166 18.1411 9.06909 17.9961 8.92395C17.8512 8.77867 17.7529 8.59554 17.7013 8.37457C17.5968 7.86221 17.4453 7.38999 17.2467 6.95791C17.0479 6.52582 16.8005 6.09193 16.5044 5.65624C16.3866 5.46304 16.3259 5.26797 16.3223 5.07103C16.3187 4.87422 16.3929 4.6911 16.545 4.52166C16.7006 4.36624 16.8733 4.30159 17.0632 4.3277C17.2532 4.35381 17.4086 4.45485 17.5296 4.63082C17.9575 5.21152 18.3044 5.79645 18.5702 6.38561C18.8361 6.97478 19.0315 7.62749 19.1565 8.34374C19.1943 8.56138 19.157 8.74881 19.0448 8.90603C18.9327 9.06311 18.7661 9.14166 18.545 9.14166Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">Durable execution</h3>
                      </TabLink>
                      <TabLink data-w-tab="Durable queues" className="layout-code_tab-link w-inline-block w-tab-link">
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M1.90272 15.0589C1.72661 14.9762 1.61008 14.8442 1.55314 14.6629C1.49633 14.4815 1.50758 14.3028 1.58689 14.1269L6.11272 5.23103C6.1955 5.05492 6.33015 4.94269 6.51668 4.89436C6.70335 4.84617 6.88467 4.86172 7.06064 4.94103C7.23342 5.02381 7.34828 5.15582 7.40522 5.33707C7.46203 5.51846 7.44911 5.69547 7.36647 5.86811L2.84564 14.7689C2.76286 14.9451 2.62821 15.0573 2.44168 15.1056C2.25501 15.1538 2.07536 15.1383 1.90272 15.0589ZM7.40272 15.0589C7.22661 14.9762 7.11008 14.8442 7.05314 14.6629C6.99633 14.4815 7.00758 14.3028 7.08689 14.1269L11.6127 5.23103C11.6955 5.05492 11.8302 4.94269 12.0167 4.89436C12.2033 4.84617 12.3847 4.86172 12.5606 4.94103C12.7334 5.02381 12.8483 5.15582 12.9052 5.33707C12.962 5.51846 12.9491 5.69547 12.8665 5.86811L8.34564 14.7689C8.26286 14.9451 8.12821 15.0573 7.94168 15.1056C7.75501 15.1538 7.57536 15.1383 7.40272 15.0589ZM12.9027 15.0589C12.7266 14.9762 12.6101 14.8442 12.5531 14.6629C12.4963 14.4815 12.5076 14.3028 12.5869 14.1269L17.1127 5.23103C17.1955 5.05492 17.3302 4.94269 17.5167 4.89436C17.7033 4.84617 17.8847 4.86172 18.0606 4.94103C18.2334 5.02381 18.3483 5.15582 18.4052 5.33707C18.462 5.51846 18.4491 5.69547 18.3665 5.86811L13.8456 14.7689C13.7629 14.9451 13.6282 15.0573 13.4417 15.1056C13.255 15.1538 13.0754 15.1383 12.9027 15.0589Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">Durable queues</h3>
                      </TabLink>
                      <TabLink
                        data-w-tab="Task observabiliy"
                        className="layout-code_tab-link w-inline-block w-tab-link"
                      >
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M12.9162 14.7613L17.3633 10.3144C17.5015 10.176 17.664 10.1104 17.8506 10.1173C18.0372 10.1242 18.2012 10.1969 18.3429 10.3352C18.4811 10.4767 18.5494 10.6435 18.5479 10.8354C18.5462 11.0272 18.4762 11.194 18.3379 11.3356L13.4185 16.255C13.2758 16.3999 13.1081 16.4723 12.9154 16.4723C12.7228 16.4723 12.5556 16.3999 12.414 16.255L10.0154 13.8565C9.87389 13.7148 9.8066 13.5481 9.81354 13.3563C9.82049 13.1643 9.89472 12.9976 10.0363 12.856C10.1746 12.7177 10.3405 12.6485 10.534 12.6485C10.7276 12.6485 10.8951 12.7177 11.0367 12.856L12.9162 14.7613ZM3.79437 17.6246C3.38687 17.6246 3.04847 17.4907 2.77917 17.2229C2.50972 16.9553 2.375 16.616 2.375 16.2052V3.7948C2.375 3.38397 2.50889 3.0439 2.77667 2.77459C3.04431 2.50515 3.38354 2.37042 3.79437 2.37042H7.86333C7.97375 1.88098 8.22785 1.47834 8.62562 1.16251C9.02354 0.846812 9.48153 0.688965 9.99958 0.688965C10.5129 0.688965 10.9688 0.846812 11.3673 1.16251C11.7659 1.47834 12.0238 1.88098 12.1408 2.37042H16.2048C16.6156 2.37042 16.9557 2.50515 17.225 2.77459C17.4944 3.0439 17.6292 3.38397 17.6292 3.7948V7.35271C17.6292 7.55313 17.5598 7.72153 17.421 7.85792C17.2823 7.99431 17.1122 8.06251 16.9108 8.06251C16.7094 8.06251 16.5414 7.99431 16.4067 7.85792C16.2721 7.72153 16.2048 7.55313 16.2048 7.35271V3.7948H14.9796V5.02001C14.9796 5.22028 14.9114 5.38862 14.775 5.52501C14.6386 5.6614 14.4703 5.72959 14.27 5.72959H5.72917C5.52889 5.72959 5.36056 5.6614 5.22417 5.52501C5.08778 5.38862 5.01958 5.22028 5.01958 5.02001V3.7948H3.79437V16.2052H8.26896C8.46937 16.2052 8.63778 16.2738 8.77417 16.4108C8.91056 16.5479 8.97875 16.7172 8.97875 16.9185C8.97875 17.1199 8.91056 17.2879 8.77417 17.4225C8.63778 17.5572 8.46937 17.6246 8.26896 17.6246H3.79437ZM9.99958 3.74001C10.2357 3.74001 10.4336 3.65931 10.5933 3.49792C10.7531 3.33653 10.8329 3.13945 10.8329 2.90667C10.8329 2.67056 10.7531 2.47265 10.5933 2.31292C10.4336 2.1532 10.2357 2.07334 9.99958 2.07334C9.76347 2.07334 9.56556 2.1532 9.40583 2.31292C9.24611 2.47265 9.16625 2.67056 9.16625 2.90667C9.16625 3.13945 9.24611 3.33653 9.40583 3.49792C9.56556 3.65931 9.76347 3.74001 9.99958 3.74001Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">Task observability</h3>
                      </TabLink>
                      <TabLink data-w-tab="Cron jobs" className="layout-code_tab-link w-inline-block w-tab-link">
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M9.27771 13.4506L12.4498 11.3221C12.5987 11.2219 12.6731 11.0801 12.6731 10.8967C12.6731 10.7132 12.5987 10.5678 12.4498 10.4606L9.27771 8.33187C9.10826 8.21424 8.93278 8.20424 8.75125 8.30188C8.56958 8.39937 8.47875 8.55465 8.47875 8.76771V13.0408C8.47875 13.2435 8.56958 13.3927 8.75125 13.4885C8.93278 13.5844 9.10826 13.5717 9.27771 13.4506ZM8.06542 2.08333C7.87014 2.08333 7.70792 2.01729 7.57875 1.88521C7.44958 1.75312 7.385 1.58965 7.385 1.39479C7.385 1.20007 7.44958 1.03875 7.57875 0.910833C7.70792 0.782777 7.87014 0.71875 8.06542 0.71875H11.9338C12.129 0.71875 12.2913 0.78368 12.4204 0.913541C12.5496 1.0434 12.6142 1.20632 12.6142 1.40229C12.6142 1.59701 12.5496 1.75917 12.4204 1.88875C12.2913 2.01847 12.129 2.08333 11.9338 2.08333H8.06542ZM9.99833 18.5417C8.94986 18.5417 7.9634 18.3407 7.03896 17.9388C6.11451 17.5368 5.30646 16.9903 4.61479 16.2992C3.92326 15.6082 3.37708 14.8006 2.97625 13.8765C2.57542 12.9523 2.375 11.9661 2.375 10.9179C2.375 9.86972 2.57556 8.88333 2.97667 7.95875C3.37778 7.03431 3.92417 6.22597 4.61583 5.53375C5.30736 4.84153 6.11535 4.2941 7.03979 3.89146C7.96438 3.48882 8.95097 3.2875 9.99958 3.2875C10.9368 3.2875 11.8193 3.44375 12.6471 3.75625C13.4747 4.06875 14.2097 4.50444 14.8519 5.06333L15.4819 4.43333C15.6202 4.29514 15.7801 4.22604 15.9617 4.22604C16.1433 4.22604 16.3033 4.29597 16.4417 4.43583C16.5799 4.57583 16.649 4.73667 16.649 4.91833C16.649 5.09986 16.5799 5.25979 16.4417 5.39812L15.8167 6.02312C16.32 6.58535 16.7479 7.26563 17.1004 8.06396C17.4529 8.86215 17.6292 9.81319 17.6292 10.9171C17.6292 11.966 17.4281 12.9528 17.0258 13.8777C16.6238 14.8026 16.0767 15.6103 15.3846 16.3008C14.6925 16.9914 13.8839 17.5375 12.9587 17.9392C12.0336 18.3408 11.0468 18.5417 9.99833 18.5417ZM9.99875 17.1173C11.7254 17.1173 13.1915 16.5158 14.3969 15.3127C15.6022 14.1097 16.2048 12.6447 16.2048 10.9179C16.2048 9.19125 15.6024 7.72528 14.3977 6.52C13.1928 5.31458 11.7271 4.71187 10.0004 4.71187C8.27375 4.71187 6.80771 5.31431 5.60229 6.51917C4.39701 7.72389 3.79437 9.18958 3.79437 10.9163C3.79437 12.6429 4.39674 14.1081 5.60146 15.3119C6.80632 16.5155 8.27208 17.1173 9.99875 17.1173Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">Cron jobs</h3>
                      </TabLink>
                      <TabLink
                        data-w-tab="Human-in-the-loop"
                        className="layout-code_tab-link w-inline-block w-tab-link"
                      >
                        <div className="layout507_tab-icon w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M10.0027 18.5027C9.53287 18.5027 9.13058 18.3351 8.79586 18C8.46114 17.6649 8.29378 17.2619 8.29378 16.7912H11.7117C11.7117 17.2628 11.544 17.6659 11.2086 18.0006C10.8732 18.3353 10.4712 18.5027 10.0027 18.5027ZM3.91878 15.9579C3.71836 15.9579 3.54996 15.8894 3.41357 15.7523C3.27718 15.6152 3.20898 15.446 3.20898 15.2446C3.20898 15.0432 3.27718 14.8751 3.41357 14.7404C3.54996 14.6058 3.71836 14.5385 3.91878 14.5385H4.83086V8.32979C4.83086 7.13423 5.18044 6.05944 5.87961 5.10541C6.57864 4.15138 7.50725 3.55131 8.66544 3.3052V2.87687C8.66544 2.50465 8.79523 2.18833 9.05482 1.92791C9.3144 1.66736 9.62954 1.53708 10.0002 1.53708C10.3219 1.53708 10.5983 1.63444 10.8294 1.82916C11.0604 2.02402 11.2153 2.26395 11.2942 2.54895V2.50416C11.0843 2.81847 10.9241 3.15673 10.8136 3.51895C10.7032 3.88131 10.644 4.25576 10.6361 4.64229C10.5275 4.61451 10.4238 4.59715 10.325 4.5902C10.2263 4.58326 10.118 4.57979 10.0002 4.57979C8.95857 4.57979 8.07315 4.9452 7.34398 5.67604C6.61482 6.40687 6.25023 7.29145 6.25023 8.32979V14.5385H13.7502V8.69166C13.9884 8.74986 14.2258 8.7859 14.4623 8.79979C14.699 8.81368 14.9364 8.80173 15.1746 8.76395V14.5385H16.0817C16.2817 14.5385 16.4508 14.6071 16.589 14.7442C16.7273 14.8812 16.7965 15.0505 16.7965 15.2519C16.7965 15.4533 16.7273 15.6212 16.589 15.7558C16.4508 15.8906 16.2817 15.9579 16.0817 15.9579H3.91878ZM14.665 7.12812C14.0038 7.12812 13.4431 6.89666 12.9829 6.43374C12.5228 5.97097 12.2927 5.40888 12.2927 4.74749C12.2927 4.08624 12.5238 3.52479 12.9861 3.06312C13.4483 2.60131 14.0095 2.37041 14.6698 2.37041C15.3301 2.37041 15.8911 2.60222 16.3529 3.06583C16.8146 3.5293 17.0454 4.09208 17.0454 4.75416C17.0454 5.41499 16.8141 5.9759 16.3513 6.43687C15.8884 6.8977 15.3263 7.12812 14.665 7.12812Z"
                              fill="currentColor"
                            />
                            {'\n'}
                          </svg>
                        </div>
                        <h3 className="heading-style-h6">Human in the loop</h3>
                      </TabLink>
                    </div>
                    <TabContent className="layout-code_tabs-content w-tab-content" morphHeight>
                      <TabPane data-w-tab="AI agents" className="layout-code_tab-pane w-tab-pane w--tab-active">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                {'Build reliable & observable AI agents'}
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Use durable workflows to make AI agents fault-tolerant, observable, and reproducible.
                                  Integrate natively with popular agent frameworks like Pydantic AI, LlamaIndex, the
                                  OpenAI Agents SDK, and the Vercel AI SDK.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/ai/ai-quickstart"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="layout-code_code-block">
                              <div className="code_card-file-bar">
                                <div className="code_card-bubble-wrapper">
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                </div>
                                <div className="text-size-tiny text-color-comment">agent.py</div>
                              </div>
                              <CodeSource
                                code={
                                  'from dbos_openai_agents import DBOSRunner\n\n# Define a tool for your agent\n@function_tool\n@DBOS.step()\nasync def get_weather(city: str) -> str:\n\u00a0\u00a0\u00a0\u00a0"""Get the weather for a city."""\n\u00a0\u00a0\u00a0\u00a0return f"Sunny in {city}"\n\n# Create an agentic workflow\n@DBOS.workflow()\nasync def run_agent(user_input: str) -> str:\n\u00a0\u00a0\u00a0\u00a0agent = Agent(name="weather", tools=[get_weather])\n\u00a0\u00a0\u00a0\u00a0result = await DBOSRunner.run(agent, user_input)\n\u00a0\u00a0\u00a0\u00a0return str(result.final_output)'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane data-w-tab="Durable execution" className="layout-code_tab-pane w-tab-pane">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                Orchestrate durable workflows
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Write your business logic in normal code, with branches, loops, subtasks, and retries.
                                  DBOS makes it resilient to any failure.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/python/tutorials/workflow-tutorial"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="layout-code_code-block">
                              <div className="code_card-file-bar">
                                <div className="code_card-bubble-wrapper">
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                </div>
                                <div className="text-size-tiny text-color-comment">checkout.py</div>
                              </div>
                              <CodeSource
                                code={
                                  "@DBOS.workflow()\ndef checkout_workflow(items: Items):\n\u00a0\u00a0\u00a0\u00a0# First, create an order\n\u00a0\u00a0\u00a0\u00a0order = create_order()\n\u00a0\u00a0\u00a0\u00a0# Then, reserve inventory\n\u00a0\u00a0\u00a0\u00a0reserve_inventory(order, items)\n\u00a0\u00a0\u00a0\u00a0# Next, process payment\n\u00a0\u00a0\u00a0\u00a0payment_status = process_payment(order, items)\n\u00a0\u00a0\u00a0\u00a0if payment_status == 'paid':\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0# If payment succeeds, fulfill the order\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0fulfill_order(order)\n\u00a0\u00a0\u00a0\u00a0else:\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0# If payment fails, release inventory\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0# and cancel the order\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0undo_reserve_inventory(order, items)\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0cancel_order(order)"
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane data-w-tab="Durable queues" className="layout-code_tab-pane w-tab-pane">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                Scale reliably with durable queues
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Use durable queues to simplify fault-tolerant orchestration of thousands of concurrent
                                  tasks. Control how many tasks can run concurrently or how often tasks can start.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/python/tutorials/queue-tutorial"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="layout-code_code-block">
                              <div className="code_card-file-bar">
                                <div className="code_card-bubble-wrapper">
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                </div>
                                <div className="text-size-tiny text-color-comment">queue.py</div>
                              </div>
                              <CodeSource
                                code={
                                  '# Create a named queue for indexing tasks,\n# It runs no more than 10 functions concurrently\nqueue = Queue("indexing_queue", concurrency=10)\n\n@DBOS.workflow()\ndef indexing_workflow(urls):\n\u00a0\u00a0\u00a0\u00a0handles = []\n\u00a0\u00a0\u00a0\u00a0# Enqueue an index task for each URL\n\u00a0\u00a0\u00a0\u00a0for url in urls:\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0handle = queue.enqueue(index_doc, url)\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0handles.append(handle)\n\u00a0\u00a0\u00a0\u00a0# Wait for each task to complete\n\u00a0\u00a0\u00a0\u00a0# and get result\n\u00a0\u00a0\u00a0\u00a0return [h.get_result() for h in handles]'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane data-w-tab="Task observabiliy" className="layout-code_tab-pane w-tab-pane">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                Monitor workflows and queues in real time
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Get real-time visibility into workflow health and performance. Inspect workflow
                                  executions, track queue metrics, and cancel, resume, or restart your workflows from
                                  the dashboard.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/production/workflow-management"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="code_card-image-wrapper w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <img
                                src="/assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table.avif"
                                // Not lazy, with its size given: it sits in a hidden tab, so lazy loading
                                // only fetched it once the tab opened, and the tab jumped when it arrived.
                                width={2953}
                                height={1289}
                                // Low priority: it's in a hidden tab, so it shouldn't compete with what's visible.
                                fetchPriority="low"
                                alt=""
                                sizes="(min-width: 1440px) 1200px, 85vw"
                                srcSet="/assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table-p-500.avif 500w, /assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table-p-800.avif 800w, /assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table-p-1080.avif 1080w, /assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table-p-1600.avif 1600w, /assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table-p-2000.avif 2000w, /assets/images/69d34406334787664d67237e_987b190197be5b770c199788b7f82a72_dbos-workflow-table.avif 2953w"
                                className="layout_card-image"
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane data-w-tab="Cron jobs" className="layout-code_tab-pane w-tab-pane">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                Dynamic cron schedules made easy
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Schedule durable workflows to run exactly once per interval. Create, update, or
                                  backfill schedules dynamically without managing external schedulers.
                                  <br />
                                  <br />
                                  Record a stock's price once a minute, migrate customer data once every hour, or send
                                  emails to inactive users once a week.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/python/tutorials/scheduled-workflows"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="layout-code_code-block">
                              <div className="code_card-file-bar">
                                <div className="code_card-bubble-wrapper">
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                </div>
                                <div className="text-size-tiny text-color-comment">create-schedule.py</div>
                              </div>
                              <CodeSource
                                code={
                                  '@DBOS.workflow()\ndef customer_workflow(scheduled_time: datetime, customer_id: str):\n\u00a0\u00a0\u00a0\u00a0# Code to sync customer data\n\u00a0\u00a0\u00a0\u00a0...\n\ndef on_customer_registration(customer_id: str):\n\u00a0\u00a0\u00a0\u00a0# Create a schedule dynamically per user\n\u00a0\u00a0\u00a0\u00a0# to run the customer_workflow\n\u00a0\u00a0\u00a0\u00a0DBOS.create_schedule(\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0schedule_name=f"cus-{customer_id}-sync",\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0workflow_fn=customer_workflow,\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0schedule="0 * * * *",\u00a0\u00a0# Runs every hour\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0context=customer_id,\n\u00a0\u00a0\u00a0\u00a0)'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                      <TabPane data-w-tab="Human-in-the-loop" className="layout-code_tab-pane w-tab-pane">
                        <div
                          data-wf--hero-code-card--variant="new"
                          className="hero-code_card w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                        >
                          <div className="code_card-content-left">
                            <div className="layout507_card-content-top w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                              <h4 className="heading-style-h3 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                Run human-in-the-loop workflows
                              </h4>
                              <div
                                id="w-node-_243f5579-2126-0819-27d6-c831b1601873-6ae64f3b"
                                className="margin-bottom margin-xsmall w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <p className="text-body-active w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386 w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                                  Run workflows that pause, wait for human input, and resume reliably, even across
                                  restarts and redeploys.
                                  <br />
                                  <br />
                                  Durable sleep and notifications let workflows wait for days or weeks, or until an
                                  external signal arrives, before continuing.
                                </p>
                              </div>
                              <div
                                id="w-node-b71e754c-2457-e8dc-c0c1-e6536ae64f42-6ae64f3b"
                                className="button-group w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386"
                              >
                                <div data-wf--button--variant="primary-small" className="button-border">
                                  <a
                                    href="https://console.dbos.dev/"
                                    className="button w-variant-994f37b3-22b0-4f81-d97c-d1ee7a18cd8b"
                                  >
                                    Start building
                                  </a>
                                </div>
                                <div
                                  data-wf--button--variant="secondary-small"
                                  className="button-border w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                >
                                  <a
                                    href="https://docs.dbos.dev/python/examples/agent-inbox"
                                    className="button w-variant-bca4b8d9-021f-aac3-f269-a152652ab5d0"
                                  >
                                    See an example
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="code_card-content-right w-variant-b7dfdd8f-0d50-4d0e-6157-59838dd53386">
                            <div className="layout-code_code-block">
                              <div className="code_card-file-bar">
                                <div className="code_card-bubble-wrapper">
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                  <div className="code_card-bubble" />
                                </div>
                                <div className="text-size-tiny text-color-comment">human-in-the-loop.py</div>
                              </div>
                              <CodeSource
                                code={
                                  '@DBOS.workflow()\ndef durable_agent(request):\n\u00a0\u00a0\u00a0\u00a0# Upon reaching a step that needs approval,\n\u00a0\u00a0\u00a0\u00a0# await an approval notification.\n\u00a0\u00a0\u00a0\u00a0approval = DBOS.recv()\n\u00a0\u00a0\u00a0\u00a0# If approved, continue execution.\n\u00a0\u00a0\u00a0\u00a0# Otherwise, raise an exception to stop execution\n\u00a0\u00a0\u00a0\u00a0if approval is None:\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0raise Exception("Agent timed out awaiting")\n\u00a0\u00a0\u00a0\u00a0elif approval.response == "deny":\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0raise Exception("Agent denied approval")\n\u00a0\u00a0\u00a0\u00a0else:\n\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0\u00a0print("Agent approved:", agent_status)\n\n@app.post("/agents/{agent_id}/respond")\ndef respond_to_agent(agent_id, response):\n\u00a0\u00a0\u00a0\u00a0# Notify an agent it has been approved or denied\n\u00a0\u00a0\u00a0\u00a0DBOS.send(agent_id, response)'
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </TabPane>
                    </TabContent>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section_logo">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-small padding-bottom">
              <div className="margin-top margin-large">
                <div className="logo1_component">
                  <div className="logo1_content">
                    <div className="logo_list-wrapper w-dyn-list">
                      <div role="list" className="logo_list-collection w-dyn-items">
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="/case-studies/bms" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/684a48c338268a5fc2bac97a_BMS-Logo.svg"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6a0dc63055842404afb10bfd_Notion-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/69e64d266dcfe6a36e0767c7_walmart-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/69d4b4518528e6ebe275300a_Roche.svg"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6a19b23a8e89f3b1180fe648_SeatGeek-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/692f972f7e0e5c80fdd2c6a2_Luma-AI-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a
                            href="/case-studies/yutori-large-scale-durable-agentic-ai"
                            className="logo_list-link w-inline-block"
                          >
                            <img
                              src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6a26576fff679ec1b66fd004_Avnet-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/69fca0f55bf9e8e1d151777b_Stuut-logo.svg"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a
                            href="/case-studies/orderful-resilient-edi-at-scale"
                            className="logo_list-link w-inline-block"
                          >
                            <img
                              src="/assets/cms/69b0d4f7613c2dba1c87abdb_Orderful-logo2.svg"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6a265740d597c8e6798da957_MUFG-logo2.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6aa8c77c60d0fc55d5712490_Nocd-logo2.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6aa8c838c08215604ff2c930_Nory-logo2.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6aa8c85f663da3860bd38036_LatchBio-logo2.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="/case-studies/dosu" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/6aa8ca1dec37f05df1b56358_Andel-Org-logo2.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/692f98c5782404bdf8e4410e_Pelican-logo.png"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                        <div role="listitem" className="logo_list-item w-dyn-item">
                          <a href="#" className="logo_list-link w-inline-block">
                            <img
                              src="/assets/cms/684a4794b2e8d8efc78902fa_Trustle-Logo.svg"
                              loading="lazy"
                              alt=""
                              height="Auto"
                              className="logo_list-logo"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_features">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="partnership_component is-transact">
                <div className="text-align-center">
                  <div className="margin-bottom margin-xsmall">
                    <div className="tagline-container">
                      <h2 className="text-style-tagline">Features</h2>
                    </div>
                  </div>
                  <div className="max-width-medium">
                    <div className="margin-bottom margin-small is-partner">
                      <h3 className="heading-style-h2">Reliability Shouldn't Cost Millions</h3>
                    </div>
                    <p className="text-body-active">
                      DBOS takes a radically different approach to durability that can save you millions of dollars
                      relative to costly orchestration servers like Temporal.
                    </p>
                  </div>
                </div>
                <div className="layout-2col_list is-pricing is-vs-temp">
                  <div id="w-node-_7d665c49-4829-0395-ff24-879daaa68feb-c6f7e10f" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_9071_5086)"
                          />
                          {'\n'}
                          <path
                            d="M17.732 23.381V16.619C17.732 16.4492 17.8035 16.3269 17.9465 16.2523C18.0893 16.1776 18.2374 16.1859 18.3908 16.2773L23.6157 19.6332C23.7484 19.7244 23.8148 19.8467 23.8148 20C23.8148 20.1533 23.7484 20.2756 23.6157 20.3667L18.3908 23.7227C18.2374 23.8141 18.0893 23.8224 17.9465 23.7477C17.8035 23.6731 17.732 23.5508 17.732 23.381ZM10.5538 25.7962V28.237C10.5538 28.4815 10.473 28.6846 10.3115 28.8462C10.1498 29.0077 9.94675 29.0885 9.70225 29.0885C9.45758 29.0885 9.2545 29.0077 9.093 28.8462C8.93133 28.6846 8.8505 28.4815 8.8505 28.237V23.6542C8.8505 23.4097 8.93133 23.2067 9.093 23.045C9.2545 22.8835 9.45758 22.8027 9.70225 22.8027H14.2598C14.5044 22.8027 14.7075 22.8835 14.869 23.045C15.0307 23.2067 15.1115 23.4097 15.1115 23.6542C15.1115 23.8989 15.0307 24.102 14.869 24.2635C14.7075 24.4252 14.5044 24.506 14.2598 24.506H11.7375C12.6795 26.0615 13.8866 27.2657 15.3588 28.1187C16.8308 28.9717 18.4362 29.3982 20.175 29.3982C22.013 29.3982 23.6886 28.8992 25.2018 27.9012C26.7148 26.9033 27.8442 25.5749 28.5902 23.9162C28.7149 23.6344 28.8757 23.4115 29.0725 23.2475C29.2695 23.0837 29.5069 23.0327 29.7848 23.0945C30.0461 23.1565 30.2222 23.31 30.313 23.555C30.404 23.7998 30.3872 24.0509 30.2625 24.3082C29.4125 26.3647 28.0788 28.0121 26.2613 29.2502C24.4436 30.4884 22.4148 31.1075 20.175 31.1075C18.1783 31.1075 16.3526 30.6477 14.6978 29.728C13.0431 28.8082 11.6618 27.4976 10.5538 25.7962ZM9.74025 18.9642C9.47892 18.9642 9.281 18.8741 9.1465 18.6937C9.01183 18.5134 8.96717 18.2947 9.0125 18.0375C9.14183 17.2075 9.35667 16.4451 9.657 15.7502C9.95733 15.0556 10.3496 14.3598 10.8338 13.663C10.9791 13.4352 11.1698 13.3004 11.406 13.2587C11.6422 13.2171 11.8536 13.2875 12.0403 13.47C12.2396 13.6733 12.3338 13.8982 12.323 14.1447C12.3123 14.3914 12.2363 14.637 12.095 14.8815C11.7563 15.3917 11.4802 15.9008 11.2667 16.409C11.0534 16.9172 10.8841 17.4703 10.7588 18.0685C10.6928 18.3337 10.5728 18.5492 10.399 18.7152C10.225 18.8812 10.0054 18.9642 9.74025 18.9642ZM19.026 9.73425C19.026 10.0034 18.9389 10.224 18.7648 10.396C18.5904 10.5678 18.3727 10.6867 18.1115 10.7527C17.4927 10.8781 16.924 11.0536 16.4055 11.2792C15.887 11.5051 15.3643 11.7937 14.8375 12.145C14.6057 12.2863 14.3664 12.353 14.1197 12.345C13.8732 12.3372 13.6567 12.2336 13.47 12.0342C13.2962 11.8602 13.2269 11.6562 13.2623 11.422C13.2976 11.1878 13.4208 10.9961 13.632 10.8467C14.3328 10.3461 15.0378 9.94867 15.7468 9.6545C16.4558 9.3605 17.2337 9.1405 18.0805 8.9945C18.3377 8.95317 18.5596 9.00083 18.7463 9.1375C18.9328 9.27417 19.026 9.47308 19.026 9.73425ZM26.518 12.0342C26.3313 12.2414 26.1147 12.3418 25.8682 12.3355C25.6216 12.3292 25.3823 12.2534 25.1505 12.1082C24.6237 11.7607 24.1062 11.4773 23.598 11.258C23.0898 11.0385 22.5283 10.8681 21.9135 10.7467C21.6483 10.6974 21.4328 10.5837 21.2668 10.4055C21.1009 10.2272 21.018 10.0034 21.018 9.73425C21.018 9.47308 21.1081 9.27417 21.2883 9.1375C21.4686 9.00083 21.6873 8.95317 21.9445 8.9945C22.7707 9.13183 23.5363 9.3455 24.2413 9.6355C24.9464 9.92567 25.641 10.3191 26.325 10.8157C26.5402 10.9691 26.6727 11.1638 26.7227 11.4C26.7727 11.6362 26.7045 11.8476 26.518 12.0342ZM30.2538 18.97C29.9886 18.97 29.769 18.8829 29.595 18.7087C29.4212 18.5344 29.3033 18.3147 29.2413 18.0495C29.1159 17.4347 28.9341 16.868 28.6958 16.3495C28.4573 15.831 28.1603 15.3103 27.805 14.7875C27.6637 14.5557 27.5908 14.3216 27.5865 14.0852C27.5822 13.8491 27.6713 13.6293 27.8538 13.426C28.0404 13.2395 28.2477 13.1619 28.4755 13.1932C28.7035 13.2246 28.8901 13.3458 29.0352 13.557C29.5487 14.2538 29.965 14.9557 30.284 15.6627C30.603 16.3697 30.8375 17.153 30.9875 18.0125C31.0328 18.2737 30.9882 18.4986 30.8535 18.6872C30.719 18.8757 30.5191 18.97 30.2538 18.97Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9071_5086"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Run Anywhere</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      DBOS runs wherever your code runs - even in air-gapped environments.
                    </p>
                  </div>
                  <div id="w-node-_7d665c49-4829-0395-ff24-879daaa68ff3-c6f7e10f" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_9071_5099)"
                          />
                          {'\n'}
                          <path
                            d="M10.2832 26.0708C10.0719 25.9714 9.93208 25.813 9.86375 25.5955C9.79558 25.3778 9.80908 25.1634 9.90425 24.9523L15.3352 14.2773C15.4346 14.0659 15.5962 13.9313 15.82 13.8733C16.044 13.8154 16.2616 13.8341 16.4727 13.9293C16.6801 14.0286 16.8179 14.187 16.8863 14.4045C16.9544 14.6222 16.9389 14.8346 16.8397 15.0418L11.4147 25.7228C11.3154 25.9341 11.1538 26.0688 10.93 26.1268C10.706 26.1846 10.4904 26.1659 10.2832 26.0708ZM16.8832 26.0708C16.6719 25.9714 16.5321 25.813 16.4637 25.5955C16.3956 25.3778 16.4091 25.1634 16.5043 24.9523L21.9352 14.2773C22.0346 14.0659 22.1962 13.9313 22.42 13.8733C22.644 13.8154 22.8616 13.8341 23.0727 13.9293C23.2801 14.0286 23.4179 14.187 23.4863 14.4045C23.5544 14.6222 23.5389 14.8346 23.4398 15.0418L18.0147 25.7228C17.9154 25.9341 17.7538 26.0688 17.53 26.1268C17.306 26.1846 17.0904 26.1659 16.8832 26.0708ZM23.4833 26.0708C23.2719 25.9714 23.1321 25.813 23.0637 25.5955C22.9956 25.3778 23.0091 25.1634 23.1042 24.9523L28.5352 14.2773C28.6346 14.0659 28.7962 13.9313 29.02 13.8733C29.244 13.8154 29.4616 13.8341 29.6727 13.9293C29.8801 14.0286 30.0179 14.187 30.0863 14.4045C30.1544 14.6222 30.1389 14.8346 30.0398 15.0418L24.6148 25.7228C24.5154 25.9341 24.3538 26.0688 24.13 26.1268C23.906 26.1846 23.6904 26.1659 23.4833 26.0708Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9071_5099"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Zero New Overhead</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      DBOS turns your Postgres DB into an orchestration server. No need to host and operate a separate
                      orchestration server.
                    </p>
                  </div>
                  <div id="w-node-_8e264855-b761-f2bc-a947-3e5b9b4aaf0e-c6f7e10f" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_9071_5099)"
                          />
                          {'\n'}
                          <path
                            d="M10.2832 26.0708C10.0719 25.9714 9.93208 25.813 9.86375 25.5955C9.79558 25.3778 9.80908 25.1634 9.90425 24.9523L15.3352 14.2773C15.4346 14.0659 15.5962 13.9313 15.82 13.8733C16.044 13.8154 16.2616 13.8341 16.4727 13.9293C16.6801 14.0286 16.8179 14.187 16.8863 14.4045C16.9544 14.6222 16.9389 14.8346 16.8397 15.0418L11.4147 25.7228C11.3154 25.9341 11.1538 26.0688 10.93 26.1268C10.706 26.1846 10.4904 26.1659 10.2832 26.0708ZM16.8832 26.0708C16.6719 25.9714 16.5321 25.813 16.4637 25.5955C16.3956 25.3778 16.4091 25.1634 16.5043 24.9523L21.9352 14.2773C22.0346 14.0659 22.1962 13.9313 22.42 13.8733C22.644 13.8154 22.8616 13.8341 23.0727 13.9293C23.2801 14.0286 23.4179 14.187 23.4863 14.4045C23.5544 14.6222 23.5389 14.8346 23.4398 15.0418L18.0147 25.7228C17.9154 25.9341 17.7538 26.0688 17.53 26.1268C17.306 26.1846 17.0904 26.1659 16.8832 26.0708ZM23.4833 26.0708C23.2719 25.9714 23.1321 25.813 23.0637 25.5955C22.9956 25.3778 23.0091 25.1634 23.1042 24.9523L28.5352 14.2773C28.6346 14.0659 28.7962 13.9313 29.02 13.8733C29.244 13.8154 29.4616 13.8341 29.6727 13.9293C29.8801 14.0286 30.0179 14.187 30.0863 14.4045C30.1544 14.6222 30.1389 14.8346 30.0398 15.0418L24.6148 25.7228C24.5154 25.9341 24.3538 26.0688 24.13 26.1268C23.906 26.1846 23.6904 26.1659 23.4833 26.0708Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9071_5099"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Keeps Your Data Safer</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      DBOS stores workflow data in your Postgres database, totally under your control.
                    </p>
                  </div>
                  <div id="w-node-_7d665c49-4829-0395-ff24-879daaa68ffb-c6f7e10f" className="layout-2col_item">
                    <div className="margin-bottom margin-tiny">
                      <div className="w-embed">
                        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                          {'\n'}
                          <rect
                            x="0.5"
                            y="0.5"
                            width="39"
                            height="39"
                            rx="3.5"
                            stroke="url(#paint0_linear_9071_5103)"
                          />
                          {'\n'}
                          <path
                            d="M14.6288 29.3722C14.4546 29.1979 14.3675 28.9978 14.3675 28.772C14.3675 28.5462 14.4544 28.3462 14.6283 28.1722L19.7065 23.1C20.0337 22.7602 20.4357 22.5934 20.9125 22.5997C21.3893 22.6061 21.7913 22.7728 22.1185 23.1L24.4 25.3815L29.2033 20.6032C29.3746 20.4332 29.5738 20.3492 29.801 20.3512C30.0282 20.3532 30.2268 20.4379 30.3968 20.6052C30.5668 20.7726 30.6518 20.9714 30.6518 21.2017C30.6518 21.4322 30.5668 21.6326 30.3968 21.8027L25.5935 26.6C25.2655 26.9272 24.8665 27.0907 24.3965 27.0907C23.9263 27.0907 23.5277 26.9272 23.2005 26.6L20.9 24.2995L15.8218 29.3777C15.6478 29.5476 15.4478 29.6315 15.222 29.6295C14.9962 29.6277 14.7984 29.5419 14.6288 29.3722ZM11.5538 29.1495C11.0941 29.1495 10.6953 28.9806 10.3573 28.6427C10.0194 28.3051 9.8505 27.9062 9.8505 27.4462V12.0537C9.8505 11.5921 10.0194 11.1918 10.3573 10.853C10.6949 10.514 11.0938 10.3445 11.5538 10.3445H26.4463C26.9079 10.3445 27.3082 10.514 27.647 10.853C27.986 11.1918 28.1555 11.5921 28.1555 12.0537V16.9342C28.1555 17.1746 28.0725 17.3766 27.9065 17.5402C27.7407 17.7039 27.5378 17.7857 27.2978 17.7857H11.5538V29.1495ZM11.5538 16.1245H26.4463V12.0537H11.5538V16.1245Z"
                            fill="#F3F6F8"
                          />
                          {'\n'}
                          <defs>
                            {'\n'}
                            <linearGradient
                              id="paint0_linear_9071_5103"
                              x1="19.4792"
                              y1="0"
                              x2="39.2187"
                              y2="0"
                              gradientUnits="userSpaceOnUse"
                            >
                              {'\n'}
                              <stop stopColor="#C8F62E" />
                              {'\n'}
                              <stop offset="0.166667" stopColor="#87FB6B" />
                              {'\n'}
                              <stop offset="0.333333" stopColor="#3FFA9F" />
                              {'\n'}
                              <stop offset="0.5" stopColor="#00F5CC" />
                              {'\n'}
                              <stop offset="0.666667" stopColor="#00ECEC" />
                              {'\n'}
                              <stop offset="0.833333" stopColor="#48E1FE" />
                              {'\n'}
                              <stop offset="1" stopColor="#80D4FF" />
                              {'\n'}
                            </linearGradient>
                            {'\n'}
                          </defs>
                          {'\n'}
                        </svg>
                      </div>
                    </div>
                    <div className="margin-bottom margin-tiny">
                      <h4 className="heading-style-h5">Large Scale, Low Latency</h4>
                    </div>
                    <p className="text-body-active text-size-regular">
                      DBOS customers run many thousands of workflows per second with lower latency than Temporal.
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_layout-benefits">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout-2col_component">
                <div className="margin-bottom margin-tiny">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container_glow">
                        <h2 className="text-size-small tagline-container is-glow">How it works</h2>
                      </div>
                    </div>
                    <div className="max-width-medium">
                      <div className="margin-bottom margin-small is-partner">
                        <h3 className="heading-style-h2">Easy as 1-2-3</h3>
                      </div>
                      <div className="margin-bottom margin-small">
                        <p className="text-body-active">
                          DBOS makes it simple to build durable, fault-tolerant applications and AI agents at any scale.
                        </p>
                      </div>
                      <div className="button-group is-center">
                        <div data-wf--button--variant="primary-large" className="button-wrapper">
                          <a href="https://console.dbos.dev/" className="button w-inline-block">
                            <div className="text-block-4">Start for free</div>
                            <div className="icon-chevron-right w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <HowItWorks className="w-layout-grid layout-2col_list is-how-it-works" as="div">
                  <div id="w-node-_3ecb0c5f-4f56-d676-f4c2-e0970b750646-c6f7e10f" className="layout-2col_item is-how">
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <div className="product-visual-bg" />
                        <Lottie
                          data-is-ix2-target="1"
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d3084bd9b93f96c034d842_d67158582f1571868cda3502b9b7210f_Embed.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-xsmall is-step">
                        <div className="tagline-container text-size-small">Step 1</div>
                        <Lottie
                          data-is-ix2-target="1"
                          className="loader-ring"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d0c63890a39ed2c88fb996_Loop.json"
                          data-loop="1"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h4">Install DBOS</h3>
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <p className="text-body-active text-size-regular">
                          Just install the open-source DBOS library to your code and connect it to a Postgres database.
                          No new infrastructure required.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div id="w-node-_7664843e-20b6-f544-fb87-63035b701665-c6f7e10f" className="layout-2col_item is-how">
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <div className="product-visual-bg" />
                        <Lottie
                          data-is-ix2-target="1"
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d308cccca0a89817ad9313_Annotate.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-xsmall is-step">
                        <div className="tagline-container text-size-small">Step 2</div>
                        <Lottie
                          data-is-ix2-target="1"
                          className="loader-ring"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d0c63890a39ed2c88fb996_Loop.json"
                          data-loop="1"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h4">Annotate your code</h3>
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <p className="text-body-active text-size-regular">
                          Annotate workflows and steps in your code to make your applications fault-tolerant and
                          observable by default.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div id="w-node-_93d05d05-37b4-df4d-5ae1-c9e5ec13b422-c6f7e10f" className="layout-2col_item is-how">
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <div className="product-visual-bg" />
                        <Lottie
                          data-is-ix2-target="1"
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d3085b75c38f7e7959803c_Observe.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-xsmall is-step">
                        <div className="tagline-container text-size-small">Step 3</div>
                        <Lottie
                          data-is-ix2-target="1"
                          className="loader-ring"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d0c63890a39ed2c88fb996_Loop.json"
                          data-loop="1"
                          data-direction="1"
                          data-autoplay="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <h3 className="heading-style-h4">Manage your workflows</h3>
                      </div>
                      <div className="margin-bottom margin-tiny">
                        <p className="text-body-active text-size-regular">
                          Use DBOS Conductor to facilitate workflow and queue troubleshooting, alerting, and remediation
                          for all your apps.
                        </p>
                      </div>
                    </div>
                  </div>
                </HowItWorks>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <header className="section_testimonial-feature">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="testimonial-feature_component">
                <div className="w-layout-grid testimonial-feature_content is-contained">
                  <div className="testimonial-feature_content-left">
                    <div className="margin-bottom">
                      <p className="text-size-xlarge is-quote">
                        {'“The '}
                        <span className="text-highlight-white">impact on observability</span>
                        {' has been huge...so we have '}
                        <span className="text-highlight-white">a lot better statistics</span>
                        {' on how things fail, why things fail...It’s '}
                        <span className="text-highlight-white">simplified our infrastructure</span>.”
                        <br />
                      </p>
                    </div>
                    <div className="testimonial-feature_content-profile">
                      <div className="testimonial-feature_content-name">
                        <p className="text-size-medium text-weight-medium is-profile">Devin Stein</p>
                        <p className="text-body-active is-profile">Founder, Dosu.dev</p>
                      </div>
                      <img
                        src="/assets/images/69158ae51d6198b2b3b474ec_Dosu.avif"
                        loading="lazy"
                        alt=""
                        className="testimonial34_tab-logo"
                      />
                    </div>
                    <div data-wf--button--variant="secondary-small" className="button-wrapper">
                      <a
                        href="/case-studies/dosu"
                        className="button w-variant-4864a870-d315-9569-ac8b-4ceaecb0466d w-inline-block"
                      >
                        <div className="text-block-4">Read case study</div>
                        <div className="icon-chevron-right w-variant-4864a870-d315-9569-ac8b-4ceaecb0466d w-embed">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                              fill="#F3F6F8"
                            />
                            {'\n'}
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="testimonial-feature_video">
                    <Lightbox
                      href="#"
                      className="testimonial-feature_lightbox w-inline-block w-lightbox"
                      config={{
                        items: [
                          {
                            url: 'https://www.youtube.com/watch?v=OjDeN_-rsJ8',
                            originalUrl: 'https://www.youtube.com/watch?v=OjDeN_-rsJ8',
                            width: 940,
                            height: 528,
                            thumbnailUrl: 'https://i.ytimg.com/vi/OjDeN_-rsJ8/hqdefault.jpg',
                            html: '<iframe class="embedly-embed" src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fwww.youtube.com%2Fembed%2FOjDeN_-rsJ8%3Ffeature%3Doembed&display_name=YouTube&url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3DOjDeN_-rsJ8&image=https%3A%2F%2Fi.ytimg.com%2Fvi%2FOjDeN_-rsJ8%2Fhqdefault.jpg&type=text%2Fhtml&schema=youtube" width="940" height="528" scrolling="no" title="YouTube embed" frameborder="0" allow="autoplay; fullscreen; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>',
                            type: 'video',
                          },
                        ],
                        group: '',
                      }}
                    >
                      <img
                        sizes="(max-width: 479px) 100vw, (max-width: 2253px) 49vw, 1104px"
                        srcSet="/assets/images/6915882db7f1468ef563524a_8b33a5dc0bb202328a2c6b5db995ca0f_Dosu-Devin-Stein-p-500.avif 500w, /assets/images/6915882db7f1468ef563524a_8b33a5dc0bb202328a2c6b5db995ca0f_Dosu-Devin-Stein-p-800.avif 800w, /assets/images/6915882db7f1468ef563524a_8b33a5dc0bb202328a2c6b5db995ca0f_Dosu-Devin-Stein-p-1080.avif 1080w, /assets/images/6915882db7f1468ef563524a_8b33a5dc0bb202328a2c6b5db995ca0f_Dosu-Devin-Stein.avif 1104w"
                        alt=""
                        src="/assets/images/6915882db7f1468ef563524a_8b33a5dc0bb202328a2c6b5db995ca0f_Dosu-Devin-Stein.avif"
                        loading="eager"
                        className="testimonial-feature_lightbox-image"
                      />
                      <div className="lightbox-play-icon">
                        <div className="icon-embed-large w-embed">
                          <svg
                            width="72"
                            height="72"
                            viewBox="0 0 72 72"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            {'\n'}
                            <path
                              d="M8 0.5H64C68.1421 0.5 71.5 3.85786 71.5 8V64C71.5 68.1421 68.1421 71.5 64 71.5H8C3.85786 71.5 0.5 68.1421 0.5 64V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
                              stroke="#F3F6F8"
                              strokeOpacity="0.5"
                            />
                            {'\n'}
                            <rect x="4" y="4" width="64" height="64" rx="4" fill="#F3F6F8" />
                            {'\n'}
                            <path d="M27.6665 26V46L44.3332 36L27.6665 26Z" fill="#090D15" />
                            {'\n'}
                          </svg>
                        </div>
                      </div>
                      <div className="video-overlay-layer" />
                    </Lightbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </header>
      <section className="section_layout-features">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout-2col_component is-testimonials">
                <div className="margin-bottom">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container_glow">
                        <h2 className="text-size-small tagline-container is-glow">Agentic-Ready Features</h2>
                      </div>
                    </div>
                    <div className="max-width-medium">
                      <div className="margin-bottom margin-small">
                        <h3 className="heading-style-h2">{'Built for reliable agents &\u00a0workflows'}</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="w-layout-grid layout_feature-grid">
                  <div
                    id="w-node-_43840aa9-a2e7-c6f0-b141-faa9e3f6bca2-c6f7e10f"
                    className="layout-2col_item is-feature is-workflow"
                  >
                    <div className="layout_product-visual-wrapper is-workflow">
                      <Lottie
                        className="product-visual-lottie"
                        data-animation-type="lottie"
                        data-src="/assets/images/69d33fd45f73300f5fcf5636_Visualise.json"
                        data-loop="0"
                        data-direction="1"
                        data-autoplay="1"
                        data-is-ix2-target="0"
                        data-renderer="svg"
                        data-default-duration="0"
                        data-duration="4"
                        data-loading="eager"
                      />
                    </div>
                    <div className="margin-top margin-tiny">
                      <div className="div-block-73">
                        <div className="margin-bottom margin-tiny">
                          <h3 className="heading-style-h4">{'Visualize Workflows & Queues'}</h3>
                        </div>
                        <div className="margin-bottom margin-xsmall">
                          <p className="text-body-active text-size-regular">
                            Monitor and manage performance in real time.
                          </p>
                        </div>
                        <div
                          data-wf--button--variant="tertiary-large"
                          className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                        >
                          <a
                            href="https://console.dbos.dev/"
                            className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                          >
                            <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                              Start for free
                            </div>
                            <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                {'\n'}
                                <path
                                  d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                  fill="#F3F6F8"
                                />
                                {'\n'}
                              </svg>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_656d633d-8db3-4353-ce14-cfec74e2b458-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69cc49da4df18d6c350b6800_73b4b564aa7f32f967946d53e1adb4f6_Integrations.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="0"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">Integrations</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          First-party integrations with agent frameworks like OpenAI Agents, LlamaIndex, Pydantic AI,
                          and the Vercel AI SDK.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="/partners"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            View all integrations
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_724aa101-6969-e956-3dee-68c2acd66748-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d339285146792bfc334abe_MCP.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="6"
                          data-loading="eager"
                        />
                        <div className="tagline-container text-size-small is-new">New</div>
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">{'MCP\u00a0Server'}</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          Monitor and debug your workflows directly from your preferred coding agent.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="https://docs.dbos.dev/integrations/mcp"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read our quickstart
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-aae9d554-771f-f389-dd2f-001939522e09-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper is-2col">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69d3311af326e606e1a46f4e_3dadc4974615e5692784a71e76d3f958_Workflow.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="3"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">Workflow Management</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          Using DBOS Conductor, automatically recover failed workflow executions; cancel, resume, or
                          restart workflows from a dashboard; set up alerts when workflows fail; and monitor workflow
                          progress and queue status in real time—across all your AI applications.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="https://docs.dbos.dev/typescript/tutorials/workflow-management"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read our docs
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_0e4c45d5-3963-d5e9-3510-67ce9d86e4c0-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69cc5d7ce10aabab515e8977_0fdc14026602dde596eb82fd45091bb6_Security.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="0"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">{'Secure & Private'}</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          DBOS is SOC 2, GDPR and CCPA compliant. DBOS never stores your data and is fully private.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="/dbos-pricing"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Compare plans
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_74a65b93-e945-32f8-a0e8-1c1f9273699a-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69cd8c81f518e44a5f0836aa_Anywhere.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="0"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">Run Anywhere</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          Run on-prem or in any cloud. Self-host DBOS Conductor or connect from any environment.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="https://docs.dbos.dev/production/hosting-conductor"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read the docs
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    id="w-node-_7b6c23ef-7a39-d2bc-2021-246895cf2c39-c6f7e10f"
                    className="layout-2col_item is-feature"
                  >
                    <div className="margin-bottom margin-tiny">
                      <div className="layout_product-visual-wrapper">
                        <Lottie
                          className="product-visual-lottie"
                          data-animation-type="lottie"
                          data-src="/assets/images/69cc5e39e84762b24f53d7bb_Crash.json"
                          data-loop="0"
                          data-direction="1"
                          data-autoplay="1"
                          data-is-ix2-target="0"
                          data-renderer="svg"
                          data-default-duration="0"
                          data-duration="0"
                          data-loading="eager"
                        />
                      </div>
                    </div>
                    <div className="div-block-73">
                      <div className="margin-bottom margin-tiny">
                        <h4 className="heading-style-h4">Custom Alerts</h4>
                      </div>
                      <div className="margin-bottom margin-xsmall">
                        <p className="text-body-active text-size-regular">
                          Define custom alerts to notify your team of workflow orchestration issues.
                        </p>
                      </div>
                      <div
                        data-wf--button--variant="tertiary-large"
                        className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                      >
                        <a
                          href="https://docs.dbos.dev/production/alerting#creating-alerts"
                          className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                        >
                          <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                            Read the docs
                          </div>
                          <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              {'\n'}
                              <path
                                d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                fill="#F3F6F8"
                              />
                              {'\n'}
                            </svg>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_testimonials">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-medium is-testimonial">
              <div className="margin-bottom margin-medium">
                <div className="layout-2col_component is-testimonials">
                  <div className="margin-bottom">
                    <div className="text-align-center">
                      <div className="margin-bottom margin-xsmall">
                        <div className="tagline-container_glow">
                          <h2 className="text-size-small tagline-container is-glow">Testimonials</h2>
                        </div>
                      </div>
                      <div className="max-width-medium">
                        <div className="margin-bottom margin-small is-partner">
                          <h3 className="heading-style-h2">{'Loved by AI, Cloud &\u00a0Data teams'}</h3>
                        </div>
                        <div className="margin-bottom margin-small">
                          <div className="max-width-small">
                            <p className="text-body-active">
                              Helping more devs, AI engineers, and SREs orchestrate fault-tolerant workflows.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="testimonial_container">
                <InViewSection className="testimonial_component" as="div" data-ix="testimonial-carousel">
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="testimonial_loop-wrapper w-dyn-list">
                    <div role="list" className="testimonial_loop-list w-dyn-items">
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc7a5d6f311045a75214_Yutori.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"We\'ve been impressed by how lightweight and flexible DBOS is, the speed at which their team ships, and the level of support offered. We, at Yutori, are happy customers and excited to scale with DBOS."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3b20af8f7964cc68f88_abhishek-das-yutori.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Abhishek Das</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/yutori-large-scale-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc5a8f5d183a87c4b1c9_soria-analytics.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS makes it dead simple for our engineering team to build reliable, low-latency,
                                AI-powered user experiences."
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b345fda9a2ca1fd247a4_cameron-spiller-soria.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Cameron Spiller</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/soria-ai-healthcare-data-processing"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bd94ec2b1771c2ef8782_supabase.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '"I love the design of DBOS. If you\'re a gamer, it\'s like having a “save point” in your programs. If a function fails, a new function can start, picking up at the last checkpoint."'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b39f9f54ce90e624acab_paul-copplestone-supabase.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Paul Copplestone</div>
                              <p className="text-size-small text-weight-regular">{'CEO & Co-Founder'}</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/supabase"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc64e48ce50044f90307_dosu.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                “DBOS is really simple to manage. It gives us durable orchestration and observability
                                without a lot of coding and without having to run additional infrastructure.”
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b3986ca57d7a19ca98d1_devin-stein-dosu.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Devin Stein</div>
                              <p className="text-size-small text-weight-regular">CEO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/dosu"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/684a500a0f67a907833551ef_Ontologize-Logo.svg"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>
                                {
                                  '\u200d“We looked at Google Workflows, Temporal, Airflow and Celery but DBOS was the one framework that solved many pieces of the puzzle while giving us implementation flexibility.”'
                                }
                              </p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b378ad90b001f593f517_shelby-vanhooser-ontologize.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Shelby Vanhooser</div>
                              <p className="text-size-small text-weight-regular">Engineer</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/ontologize"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                      <div role="listitem" className="testimonial_loop-item w-dyn-item">
                        <div className="testimonial_card">
                          <div className="testimonial21_content-top">
                            <div className="margin-bottom margin-small">
                              <img
                                src="/assets/cms/69d4bc21bab5c6ce0d75b2f4_goblins-app.avif"
                                loading="lazy"
                                alt=""
                                className="logo_list-logo"
                              />
                            </div>
                            <div className="card-testimonial-rich w-richtext">
                              <p>{'"DBOS\u00a0makes it impossible to screw up."'}</p>
                            </div>
                          </div>
                          <div className="testimonial31_client">
                            <div className="testimonial31_client-image-wrapper">
                              <img
                                loading="lazy"
                                src="/assets/cms/69d4b38d7a410a07a9818e1a_alp-karavil-goblins.avif"
                                alt=""
                                className="testimonial31_customer-image"
                              />
                            </div>
                            <div className="testimonial_client-info">
                              <div className="text-size-regular text-weight-medium">Alp Karavil</div>
                              <p className="text-size-small text-weight-regular">CTO and Co-founder</p>
                            </div>
                          </div>
                          <div
                            data-wf--button--variant="tertiary-large"
                            className="button-wrapper w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d"
                          >
                            <a
                              href="/case-studies/goblins-durable-agentic-ai"
                              className="button w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-inline-block"
                            >
                              <div className="text-block-4 w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d">
                                Read case study
                              </div>
                              <div className="icon-chevron-right w-variant-5a10be65-1a52-78d4-7d8b-5af0413eb67d w-embed">
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  {'\n'}
                                  <path
                                    d="M8.61298 13.8735C8.51201 13.8735 8.42611 13.8405 8.35527 13.7744C8.28444 13.7083 8.24902 13.6222 8.24902 13.5163V6.48376C8.24902 6.37778 8.28541 6.29174 8.35819 6.22563C8.43083 6.15952 8.51673 6.12646 8.6159 6.12646C8.64076 6.12646 8.72395 6.16612 8.86548 6.24542L12.2428 9.62292C12.2906 9.67056 12.3291 9.72688 12.3584 9.79188C12.3878 9.85688 12.4026 9.9264 12.4026 10.0004C12.4026 10.0745 12.3878 10.1438 12.3584 10.2085C12.3291 10.2733 12.2906 10.3295 12.2428 10.3773L8.86486 13.7552C8.83083 13.7892 8.79236 13.8175 8.74944 13.84C8.70652 13.8624 8.66104 13.8735 8.61298 13.8735Z"
                                    fill="#F3F6F8"
                                  />
                                  {'\n'}
                                </svg>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </InViewSection>
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
      <section className="section_posts">
        <SlideIn className="padding-global" as="div">
          <div className="container-large">
            <div className="padding-section-large">
              <div className="layout-2col_component is-testimonials">
                <div className="margin-bottom">
                  <div className="text-align-center">
                    <div className="margin-bottom margin-xsmall">
                      <div className="tagline-container_glow">
                        <h2 className="text-size-small tagline-container is-glow">Insights</h2>
                      </div>
                    </div>
                    <div className="max-width-medium">
                      <div className="margin-bottom margin-small is-partner">
                        <h3 className="heading-style-h2">Read the latest on workflow durability</h3>
                      </div>
                      <div className="margin-bottom margin-small">
                        <p className="text-body-active">
                          {'The latest in durable execution, AI\u00a0workflows &\u00a0more.'}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <HomeRecentPosts posts={posts.slice(0, 3)} />
              </div>
            </div>
          </div>
        </SlideIn>
      </section>
    </SiteLayout>
  );
}
